import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicLayout from "../../layauots/BasicLayout";
import { Card, Alert, AlertTitle, TextField, Autocomplete } from "@mui/material";
import MDBox from "../../controls/MDBox";
import MDTypography from "../../controls/MDTypography";
import MDInput from "../../controls/MDInput";
import MDButton from "../../controls/MDButton";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import * as yup from "yup";
import { postData } from "../../Utils/Http/api";

import { fetchSujetoIdentificacion } from "../../Utils/SujetoIdentificacion";
import EstadosSiNo from "../../Utils/estadossino";
import TipoPersona from "../../Utils/TipoPersona";
const SujetoAdd = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nombre: "",
    identificacion: "",
    idSujetoTipoIdentificacion: null,
    concursado: null,
    fallecido: null,
    quebrado: null,
    tipoPersona: null,
  });
  const [elementsTipoIdentificacion, setElementsTipoIdentificacion] = useState([]);
  const [selectedTipoIdentificacion, setSelectedTipoIdentificacion] = useState(null);
  const [selectedConcursado, setSelectedConcursado] = useState(null);
  const [selectedFallecido, setSelectedFallecido] = useState(null);
  const [selectedQuebrado, setSelectedQuebrado] = useState(null);
  const [selectedTipoPersona, setSelectedTipoPersona] = useState(null);
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);
  const [grabando, setGrabando] = useState(false);
  const [nombreboton, setnombreboton] = useState("Cancelar");

  const validationSchema = yup.object().shape({
    nombre: yup.string().required("El campo Nombre es obligatorio"),

    identificacion: yup.string().required("Identificación es obligatoria"),
  });

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleVolver = () => {
    navigate("/SujetoList");
  };
  const handleAutocompleteTipoIdentificacionChange = (event, value) => {
        setSelectedTipoIdentificacion(value);
    };

  // load tipos de identificacion
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const tipos = await fetchSujetoIdentificacion();
        if (!mounted) return;
        setElementsTipoIdentificacion(tipos || []);
        setSelectedTipoIdentificacion((tipos || [])[0] || null);
      } catch (ex) {
        console.error('Error cargando tipos de identificacion', ex);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const handleSubmit = async () => {
    try {
      await validationSchema.validate(formData);
      setGrabando(true);
      setnombreboton("Volver");
      setMensaje("");
      setExito(false);

 
      const reqSujeto = {
        idSujetoTipoIdentificacion: selectedTipoIdentificacion?.idSujetoIdentificacion ?? formData.idSujetoTipoIdentificacion ?? null,
        nombre: formData.nombre,
        Identificacion: formData.identificacion,
        concursado: (selectedConcursado?.valor ?? false) ? 1 : 0,
        fallecido: (selectedFallecido?.valor ?? false) ? 1 : 0,
        quebrado: (selectedQuebrado?.valor ?? false) ? 1 : 0,
        tipoPersona: (selectedTipoPersona?.valor === 'PF') ? 1 : (selectedTipoPersona?.valor === 'PJ') ? 2 : null,
      };

      const res = await postData("/SujetoAlta", reqSujeto);

      if (res?.isSuccess) {
        setMensaje("¡Sujeto fue agregado exitosamente!");
        setExito(true);
      } else {
        setMensaje(res?.error || "Error al guardar");
        setExito(false);
        setGrabando(false);
      }
    } catch (error) {
      setMensaje(error.message || "Error de validación");
      setExito(false);
      setGrabando(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card style={{ width: "157%" }}>
        <MDBox
          variant="gradient"
          bgColor="secondary"
          borderRadius="lg"
          coloredShadow="light"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Agregar Sujeto
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Permite agregar un nuevo sujeto.
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="nombre"
                label="Nombre"
                variant="standard"
                value={formData.nombre}
                onChange={handleInputChange}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <Autocomplete
                onChange={handleAutocompleteTipoIdentificacionChange}
                options={elementsTipoIdentificacion}
                getOptionLabel={(option) => option.descripcion || 'Seleccione Tipo Identificacion'}
                value={selectedTipoIdentificacion || null}
                 getOptionSelected={(option, value) =>
                  option.idTipoIdentificacion === value.idSujetoIdentificacion
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccione Tipo Identificacion"
                    variant="outlined"
                  />

                )}
                style={{ flex: 1 }}
                defaultValue={selectedTipoIdentificacion || []}
                isOptionEqualToValue={(option, value) =>
                  option.descripcion === value.descripcion
                }
              />
              
            </MDBox>
            <MDBox mb={2} display="flex" gap={2} flexWrap="wrap">
              <Autocomplete
                options={Object.values(EstadosSiNo)}
                getOptionLabel={(o) => o.descripcion}
                value={selectedConcursado}
                onChange={(e, v) => setSelectedConcursado(v)}
                renderInput={(params) => <TextField {...params} label="Concursado" />}
                sx={{ minWidth: 220 }}
              />
              <Autocomplete
                options={Object.values(EstadosSiNo)}
                getOptionLabel={(o) => o.descripcion}
                value={selectedFallecido}
                onChange={(e, v) => setSelectedFallecido(v)}
                renderInput={(params) => <TextField {...params} label="Fallecido" />}
                sx={{ minWidth: 220 }}
              />
              <Autocomplete
                options={Object.values(EstadosSiNo)}
                getOptionLabel={(o) => o.descripcion}
                value={selectedQuebrado}
                onChange={(e, v) => setSelectedQuebrado(v)}
                renderInput={(params) => <TextField {...params} label="Quebrado" />}
                sx={{ minWidth: 220 }}
              />
              <Autocomplete
                options={Object.values(TipoPersona)}
                getOptionLabel={(o) => o.descripcion}
                value={selectedTipoPersona}
                onChange={(e, v) => setSelectedTipoPersona(v)}
                renderInput={(params) => <TextField {...params} label="Tipo Persona" />}
                sx={{ minWidth: 220 }}
              />
            </MDBox>
           
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="identificacion"
                label="Identificación"
                variant="standard"
                value={formData.identificacion}
                onChange={handleInputChange}
                fullWidth
              />
            </MDBox>

            <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
              <MDButton
                onClick={handleSubmit}
                variant="gradient"
                color="success"
                endIcon={<Save />}
                disabled={grabando}
                fullWidth
              >
                Grabar
              </MDButton>

              <MDButton
                onClick={handleVolver}
                variant="gradient"
                color="error"
                endIcon={<ExitToApp />}
                fullWidth
              >
                {nombreboton}
              </MDButton>
            </MDBox>
          </MDBox>

          {mensaje && (
            <Alert severity={exito ? "success" : "error"}>
              <AlertTitle>{exito ? "Felicitaciones" : "Error"}</AlertTitle>
              {mensaje}
            </Alert>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default SujetoAdd;
